import { Device, DeviceEldDriver, DeviceWithMapInfo } from "src/models";

export const speedPerState = { "AL": 70, "AK": 65, "AZ": 75, "AR": 65, "CA": 55, "CO": 75, "CT": 65, "DE": 65, "DC": 55, "FL": 70, "GA": 70, "HI": 60, "ID": 70, "IL": 70, "IN": 65, "IA": 70, "KS": 75, "KY": 65, "LA": 75, "ME": 75, "MD": 70, "MA": 65, "MI": 65, "MN": 70, "MS": 70, "MO": 70, "MT": 65, "NE": 75, "NV": 80, "NH": 65, "NJ": 65, "NM": 75, "NY": 65, "NC": 70, "ND": 75, "OH": 70, "OK": 75, "OR": 55, "PA": 70, "RI": 65, "SC": 70, "SD": 80, "TN": 70, "TX": 75, "UT": 75, "VT": 65, "VA": 70, "WA": 60, "WV": 70, "WI": 70, "WY": 75 };


export function overSpeed(device: DeviceWithMapInfo) {
  if (device.velocity === undefined) {
    return false;
  }

  let speedLimit = 65;
  if (device.location && device.location.length >= 2) {
    const state = device.location.substring(device.location.length - 2);
    if ((speedPerState as any)[state]) {
      speedLimit = (speedPerState as any)[state];
    }
  }

  return speedLimit + 1 < device.velocity;
}

export function getDeviceDrivers(deviceEldDrivers: DeviceEldDriver[], device: Device) {
  const t = (device.deviceType || "").replaceAll("ELD Truck #", "");
  return deviceEldDrivers.filter(d => d.eldVehicleUnitNumber === t);
}

export function getLabelFromOrigin(origin?: number): string {
  if (origin === undefined || origin === null) {
    return "";
  }
  switch (origin) {
    case 1:
      return "Samsara";
    case 2:
      return "Geometris";
    case 3:
      return "CT";
    case 4:
      return "Premier";
    case 5:
      return "Immobilizer";
    case 6:
      return "Solar";
    case 7:
      return "Wired";
    default:
      return origin.toString(); // should never get here
  }
}